<icz-section boxed label="Spisovna" [waiting]="loadingService.isLoading$(this) | async">
  @if (transferWithMainEntity?.registryOfficeTransfer; as transfer) {
    <icz-form-autocomplete [fieldDisabled]="true" label="Spisovna" [options]="registryOfficeOptions" [value]="transfer.registryOfficeId"></icz-form-autocomplete>
    <div class="row">
      <icz-date-picker [fieldDisabled]="true" class="grow" label="Předáno spisovně" [value]="transfer.handedOverAt"></icz-date-picker>
      <icz-date-picker [fieldDisabled]="true" class="grow" label="Předáno k uložení" [value]="transfer.takenOverAt"></icz-date-picker>
    </div>
    <icz-form-field [fieldDisabled]="true" label="Předal" [value]="transfer.handedOverByFunctionalPositionId | findFunctionalPositionById | async"></icz-form-field>
    <div class="row">
      <icz-form-autocomplete [fieldDisabled]="true" class="grow" label="Stav uložení" [options]="registryOfficeTransferStateOptions" [value]="transfer.registryOfficeTransferState"></icz-form-autocomplete>
      <icz-date-picker [fieldDisabled]="true" class="grow" label="Uloženo ve spisovně" [value]="transfer.acceptedAt"></icz-date-picker>
    </div>
    @if (isMainTransferEntitySectionVisible) {
      <div>
        <icz-label class="icz-body-1 mb-8" label="Ukládání jako součást"></icz-label>
        <icz-entity-info
          class="inline-block"
          [entity]="mainTransferEntity!"
          [isLink]="true"
        ></icz-entity-info>
      </div>
    }
  }
</icz-section>
